import React from 'react';
import PropTypes from 'prop-types';
import { useCurrentConversation } from '@rsos/reduxDataStore/src/features/alerts/hooks';
import { useSelectedAlert } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import {
  AlertChatBoxContainer,
  CHAT_HEADER_HEIGHT,
  TalkJSContainer,
} from '../AlertChatBox/AlertChatBox.styles';
import TalkJSPrivilegedChatbox from './TalkJSPrivilegedChatbox';

/**
 * Display an alert chat box using TalkJS when a user accepts an alert. The user can communicate
 * with a user from an external application that is also connected to the conversation
 * @param {String} chatBoxHeight - Current chat box height, the value changes if a user adjusts the split pane height.
 */
const AlertPrivilegedChatbox = ({
  chatBoxHeight,
  isChatBoxVisible,
  hasChatEnded,
}) => {
  const currentAlert = useSelectedAlert();

  const alertConversation = useCurrentConversation();

  const selectedAlertID = currentAlert?.alert_id;

  const alertConversationID = alertConversation?.privileged_conversation?.id;

  const alertActionsHeight = hasChatEnded
    ? CHAT_HEADER_HEIGHT
    : CHAT_HEADER_HEIGHT + 40;

  return (
    <AlertChatBoxContainer>
      {selectedAlertID && alertConversationID && (
        <TalkJSContainer
          chatBoxHeight={chatBoxHeight}
          alertActionsHeight={`${alertActionsHeight}px`}
          isChatBoxVisible={isChatBoxVisible}
        >
          <TalkJSPrivilegedChatbox isChatBoxVisible={isChatBoxVisible} />
        </TalkJSContainer>
      )}
    </AlertChatBoxContainer>
  );
};

AlertPrivilegedChatbox.propTypes = {
  chatBoxHeight: PropTypes.string.isRequired,
  isChatBoxVisible: PropTypes.bool,
  hasChatEnded: PropTypes.bool,
};

export default AlertPrivilegedChatbox;
